<script>

    export default {
        name: "Administrator",

        data() {
            return {
                mode: '',
                by: '',
            }
        },
        props : {
            init_mode : {
                type: String,
                default : 'permission',
            },
        },
        methods: {
            toggleMode(mode) {
                if(this.$store.state.submitting) {
                    return;
                }

                if(mode == this.mode) return;
                if (mode == 'permission') {
                    this.mode = 'permission';
                    this.by = '/system-management/system-settings/administrator/list-by-permission';
                } else if (mode == 'role'){
                    this.mode = 'role';
                    this.by = '/system-management/system-settings/administrator/list-by-role';
                } else {
                    this.mode = 'user';
                    this.by = '/system-management/system-settings/administrator/list-by-user';
                }

            },
            refresh() {
                let _url = this.by;
                let self = this;
                this.by = '';
                this.$nextTick(function(){
                    self.by = _url;
                })
            },

        },

        beforeMount() {
            if(this.init_mode) {
                this.toggleMode(this.init_mode);
            } else {
                this.mode = 'permission';
                this.toggleMode(this.mode);
            }
        },
        mounted() {
			window.eventHub.$on('refresh-data', this.refresh)
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Modules/system-management/administrator/Administrator.vue